import React from "react";
import './textarea.css';

type TextareaProps = {
    id: string;
    label: string;
    placeholder?: string;
    value?: string;
    onChange: (value: string) => void;
    rows?: number;
    cols?: number;
};

export const Textarea = ({ id, value, onChange, label, placeholder, rows, cols }: TextareaProps) => {
    return (
        <>
            <label className="field-textarea-label" htmlFor={id}>
                <b>{label}</b>
            </label>
            <textarea
                className="field-textarea-input"
                id={id} onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                cols={cols}
                rows={rows}
                value={value}
            />
        </>
    );
};